export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9474.1bb0d59d.jpg";